import React from "react";
import "../styles/Varalatrupani.css";

const Varalatrupani = () => {
  return (
    <div className="varal-container">
      <div className="varal-header">
        <h1 className="varal-title">10 நாட்கள் நடைபெற்ற சங்கத் தமிழ்ப் பயிலரங்கம்</h1>
      </div>
      <div className="varal-image-container">
        <img 
          src="https://makalukkaga.mpeoplesnet.com/podhu/podhu2.png" 
          alt="சங்கத் தமிழ்ப் பயிலரங்கம் படம்" 
          className="varal-image"
        />
      </div>
      <div className="varal-content">
        <p className="varal-paragraph">
          <span className="varal-specialText">
            மக்கள் சிந்தனைப் பேரவை அரசு நிறுவனமான செம்மொழி
          </span>{" "}
          தமிழாய்வு மத்திய நிறுவனத்துடன் இணைந்து ஆசிரியர்களுக்கான சங்கத் தமிழ்ப்
          பயிலரங்கத்தை 27.1.2009 முதல் 5.2.2009 பத்து நாட்கள் வரை ஈரோட்டில்
          நடத்தியது. ஈரோடு மாவட்டம் முழுவதிலுமிருந்து பேரவையால் தேர்வு
          செய்யப்பட்ட இளம் தமிழாசிரியர்கள் 50 பேருக்கு இப்பயிலரங்கத்தை பேரவை
          ஏற்பாடு செய்திருந்தது. இப்பயிலரங்கத்தில் தமிழகத்தில் மிகவும்
          குறிப்பிடத் தகுந்த 44 தமிழறிஞர்கள் அவரவர்களுக்குக் கொடுக்கப்பட்டிருந்த
          சிறப்புத் தலைப்புகளில் வகுப்பெடுத்தனர்.
        </p>
        <p className="varal-paragraph">
          <span className="varal-specialText">
            தொடக்க விழாவிற்கு பேராசிரியர் ஈரோடு தமிழன்பன்
          </span>{" "}
          அவர்களும் நிறைவு விழாவிற்கு பேராசிரிய ஒளவை நடராசன் அவர்களும் சிறப்பு
          அழைப்பாளர்களாகப் பங்கேற்றனர். பத்து நாட்கள் நடைபெற்ற இப்பயிலரங்கம்
          பங்கேற்ற அனைத்து ஆசிரியர்களுக்கும் மிகவும் பயனுள்ளதாக இருந்ததாக நிறைவு
          நாளில் தாங்களாக முன்வந்து கருத்துத் தெரிவித்தனர். சங்கத் தமிழை ஒரு
          சமூகப் பார்வையோடு அறிவியல் சார்ந்த கண்ணோட்டத்தில் ஆசிரியர்கள்
          முழுமையாக விளங்கிக் கொண்டு மாணவர்களுக்கு பாடம் நடத்தினால் மாணவர்கள்
          மனதில் சமய சார்பற்ற உணர்வும் தமிழ் மொழி குறித்த வித்தியாசமான புரிதலும்
          ஏற்படும் என்ற கருத்தில் இப்பயிலரங்கம் நடத்தப்பட்டது.
        </p>
        <p className="varal-paragraph">
          இதற்கு முழுப்பண உதவியும் செம்மொழி தமிழாய்வு மத்திய நிறுவனத்தின்
          சார்பில் செய்யப்பட்டது நிதி வழங்கி இணைந்து நடத்தியதன் மூலம் பேரவையின்
          செயல்பாட்டை அரசு அங்கீகரித்துள்ளதாகட் கொள்ளலாம்.
        </p>
      </div>
    </div>
  );
};

export default Varalatrupani;